/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssociatedMessageNew_lists$ref: FragmentReference;
declare export opaque type AssociatedMessageNew_lists$fragmentType: AssociatedMessageNew_lists$ref;
export type AssociatedMessageNew_lists = {|
  +id: string,
  +$refType: AssociatedMessageNew_lists$ref,
|};
export type AssociatedMessageNew_lists$data = AssociatedMessageNew_lists;
export type AssociatedMessageNew_lists$key = {
  +$data?: AssociatedMessageNew_lists$data,
  +$fragmentRefs: AssociatedMessageNew_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssociatedMessageNew_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = 'bb6e904a94efd4e7a6b9e60a82378c9a';

module.exports = node;
